import axios from 'axios';
import { API_BASE_URL, API_CIMA_SEARCH, API_CIMA_DETALLE } from '../../../helpers/urlHelper';

const api = axios.create({
  baseURL: API_BASE_URL
});

export function fetchCimaSuggestions(q) {
  const texto = (q || '').trim();
  if (!texto) {
    return Promise.resolve([]);
  }

  return api
    .get(API_CIMA_SEARCH, {
      params: { nombre: texto }
    })
    .then(res => {
      return res.data || [];
    });
}

export function fetchCimaDetalle(nregistro) {
  return api
    .get(API_CIMA_DETALLE, {
      params: { nregistro }
    })
    .then(res => {
      return res.data;
    });
}
